import { create, GetState } from 'zustand';
import { DevtoolsOptions, devtools } from 'zustand/middleware';

type StateCreator<T> = (set: (partial: T | ((state: T) => T)) => void, get: GetState<T>) => T;

const createStore = <T extends object>(createState: StateCreator<T>, options?: DevtoolsOptions | undefined) =>
  create(devtools(createState, options));

export default createStore;
